import { Component, h, Host, Prop } from '@stencil/core'

import { colors, ColorsType, FontSizeType } from '../../tailwind'

@Component({
  tag: 'ui-logo',
})
export class Logo {
  @Prop() textColor: ColorsType = 'glyph-base'
  @Prop() logoColor: ColorsType = 'brand-base'
  @Prop() showText = true
  @Prop() size: FontSizeType | number
  render() {
    const hostAttrs: any = {}
    if (typeof this.size === 'number') {
      hostAttrs.style = { fontSize: this.size + 'px' }
    } else {
      hostAttrs.class = this.size ? `text-${this.size}` : ''
    }
    return (
      <Host {...hostAttrs}>
        {this.showText ? (
          <svg viewBox='0 0 136 20' style={{ height: '1em' }}>
            <g class='transition duration-200' fill-rule='nonzero' fill='none'>
              <path
                fill={colors[this.textColor]}
                d='M0 18.5h2.9v-7.1h6.7V8.7H2.9V4.2h7.3V1.5H0zM29.8 4.2h4.9v14.3h2.9V4.2h4.9V1.5H29.8zM57.7 8.3h-7V1.5h-2.9v17h2.9V11h7v7.5h2.9v-17h-2.9zM80.4 3.6c-.7-.8-1.7-1.4-2.7-1.9-1-.5-2.2-.7-3.4-.7-1.2 0-2.4.2-3.4.7-1 .5-2 1.1-2.7 1.9-.7.8-1.3 1.8-1.8 2.9-.4 1-.7 2.2-.7 3.5 0 1.3.2 2.5.6 3.5.4 1.1 1 2.1 1.8 2.9.7.8 1.7 1.4 2.7 1.9 1 .5 2.2.7 3.4.7 1.2 0 2.4-.2 3.4-.7 1-.5 2-1.1 2.7-1.9.7-.8 1.3-1.8 1.8-2.9.4-1.1.6-2.3.6-3.5 0-1.2-.2-2.5-.6-3.5-.3-1.1-.9-2.1-1.7-2.9zm-.9 8.8c-.3.8-.7 1.4-1.1 2-.5.6-1.1 1-1.8 1.3-1.4.7-3.3.7-4.6 0-.7-.3-1.3-.8-1.8-1.3-.5-.6-.9-1.2-1.1-2-.3-.8-.4-1.6-.4-2.4 0-.9.1-1.7.4-2.4.3-.8.7-1.4 1.1-2 .5-.6 1.1-1 1.8-1.3.7-.3 1.5-.5 2.3-.5.9 0 1.6.2 2.3.5.7.3 1.3.8 1.8 1.3.5.6.9 1.2 1.1 2 .3.8.4 1.6.4 2.4 0 .9-.1 1.7-.4 2.4zM101 1.5l-4.6 12-4.7-12h-3.9v17h2.9v-12l4.7 12h1.9l4.7-12v12h2.9v-17zM28.8 18.5l-7-17h-2.3l-7.2 17h3.3l5-12.9 3.2 8.4s-2.1-1.2-4-1.2l-1 2.5c3.9 0 6.8 3.1 6.8 3.1h3.2v.1z'
              />
              <g class='transition duration-200' fill={colors[this.logoColor]}>
                <path d='M132.2 11.6l-13-7.1c-1.2-.7-1.6-2.1-.9-3.3.7-1.1 2.2-1.5 3.4-.9l13 7.1c1.2.7 1.6 2.1.9 3.3-.6 1.2-2.2 1.6-3.4.9zM126.2 15.9l-6.9-3.8c-1.2-.7-1.6-2.1-.9-3.3.7-1.1 2.2-1.5 3.4-.9l6.9 3.8c1.2.7 1.6 2.1.9 3.3-.7 1.1-2.2 1.5-3.4.9z' />
                <path
                  d='M118 17.5v-7.4c0-1.4 1.1-2.5 2.5-2.5s2.5 1.1 2.5 2.5v7.4c0 1.4-1.1 2.5-2.5 2.5s-2.5-1.1-2.5-2.5z'
                  opacity='.5'
                />
              </g>
            </g>
          </svg>
        ) : (
          <svg viewBox='117 0 20 20' style={{ height: '1em' }}>
            <g class='transition duration-200' fill-rule='nonzero' fill='none'>
              <g class='transition duration-200' fill={colors[this.logoColor]}>
                <path d='M132.2 11.6l-13-7.1c-1.2-.7-1.6-2.1-.9-3.3.7-1.1 2.2-1.5 3.4-.9l13 7.1c1.2.7 1.6 2.1.9 3.3-.6 1.2-2.2 1.6-3.4.9zM126.2 15.9l-6.9-3.8c-1.2-.7-1.6-2.1-.9-3.3.7-1.1 2.2-1.5 3.4-.9l6.9 3.8c1.2.7 1.6 2.1.9 3.3-.7 1.1-2.2 1.5-3.4.9z' />
                <path
                  d='M118 17.5v-7.4c0-1.4 1.1-2.5 2.5-2.5s2.5 1.1 2.5 2.5v7.4c0 1.4-1.1 2.5-2.5 2.5s-2.5-1.1-2.5-2.5z'
                  opacity='.5'
                />
              </g>
            </g>
          </svg>
        )}
      </Host>
    )
  }
}
